import { ICreateMarathon } from "features/createEditMarathon/model/types";
import { useFieldArray, useFormContext } from "react-hook-form";

export const useMarathonTabForm = () => {
  const {
    watch,
    register,
    control,
    setValue,
    resetField,
    clearErrors,
    formState: { errors, isDirty },
  } = useFormContext<ICreateMarathon>();

  const {
    append: appendPublicOffer,
    remove: removePublicOffer,
    insert: insertPublicOffer,
    replace: replacePublicOffer,
    update: updatePublickOffer,
  } = useFieldArray({ name: "publicOffer", control });
  const {
    fields: fieldsPartners,
    append: appendPartners,
    remove: removePartners,
  } = useFieldArray({ control, name: "partners" });

  const data = watch();

  const appendDocument = (file: File | string | null) => {
    const currentDocuments = data.documents || [];
    setValue("documents", [...currentDocuments, file]);
  };

  const removeDocument = (index: number) => {
    const currentDocuments = data.documents || [];
    setValue(
      "documents",
      currentDocuments.filter((_, i) => i !== index)
    );
  };

  return {
    clearErrors,
    updatePublickOffer,
    replacePublicOffer,
    errors,
    isDirty,
    insertPublicOffer,
    fieldsPartners,
    appendPartners,
    removePartners,
    data,
    register,
    appendDocument,
    control,
    setValue,
    removeDocument,
    resetField,
    appendPublicOffer,
    removePublicOffer,
  };
};
